// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"e57396cf","354":"e6f6b8a0","396":"5d8ca873","523":"d617ac32","647":"cebb471c","680":"becb6f81","747":"70a3591c","854":"e6868012","873":"808f07dc","957":"ed93ff3f"}[chunkId] + ".chunk.js";
};